import { render, staticRenderFns } from "./mainMenuItem.vue?vue&type=template&id=66afa342&"
import script from "./mainMenuItem.vue?vue&type=script&lang=js&"
export * from "./mainMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "mainMenuItem.vue"
export default component.exports